import "../../../CardProfile/CardProfile.scss";
import money from "../../../../../image/Company/wallet-with-card-sticking-out.png";
import deliver from "../../../../../image/Company/fast-delivery.png";
import time from "../../../../../image/Company/timer.png";
import verified from "../../../../../image/Company/shield.png";
import Header from "../../../../Header/Header";
import Footer from "../../../../Footer/Footer";
import logo1 from "../../../../../image/logotype/logo.svg";
import GoodsSlider from "../../../GoodsSlider/Phosphorus/GoodsSlider";
import Description from '../Phosphor/Description';
import Reference from '../Phosphor/Reference';
import Table from '../Molibden/Table';
import crumbs from "../../../../../icons/icons8-home.svg";
import forward_arrow from "../../../../../icons/icons-forward-arrow.png";
import { Helmet } from "react-helmet";
import { useState } from "react";
import { Link } from "react-router-dom";
import { items } from '../../../../mockData/goods-data';
import { useCart } from "../../../../cart/CartContext";

export default function ProductItem() {
  const targetItemId = "2";
  const targetItem = items.find(item => item.id === targetItemId);

  const [togglefirstState, settogglefirstState] = useState(1);
  const [toggleState, setToggleState] = useState(1);
  const { add } = useCart();

  if (!targetItem) {
    return <div>Товар з вказаним id не знайдено.</div>;
  }

  const priceFirst = targetItem.priceFirst;
  const priceSecond = targetItem.priceSecond;
  const priceThird = targetItem.priceThird;
  const priceFourth = targetItem.priceFourth;

  const toggleTab = (index) => setToggleState(index);
  const toggleFirstTab = (index) => settogglefirstState(index);

  // --- логіка як в Item.js ---
  const parsePrice = (str) => Number(String(str).replace(/[^\d]/g, "")) || 0;

  const getActiveUnit = () => {
    const units = [
      targetItem.unitFirst,
      targetItem.unitSecond,
      targetItem.unitThird,
      targetItem.unitFourth,
    ];
    return units[togglefirstState - 1] || "";
  };

  const getActivePrice = () => {
    const prices = [priceFirst, priceSecond, priceThird, priceFourth];
    return parsePrice(prices[togglefirstState - 1]);
  };

  const getActiveSku = () => {
    const skus = [
      targetItem.skuFirst,
      targetItem.skuSecond,
      targetItem.skuThird,
      targetItem.skuFourth,
    ];
    return skus[togglefirstState - 1] || targetItem.skuFirst || targetItem.sku;
  };

  const getActiveImg = () => {
    const imgs = [
      targetItem.imgFirst,
      targetItem.imgSecond,
      targetItem.imgThird,
      targetItem.imgFourth,
    ];
    return imgs[togglefirstState - 1] || targetItem.imgFirst || null;
  };

  const handleAdd = () => {
    const unit = getActiveUnit();
    const price = getActivePrice();
    const img = getActiveImg();
    const sku = getActiveSku();

    add({
      sku,
      title: targetItem.title,
      price,
      img,
      unit,
      quantity: 1,
    });
  };

  return (
    <>
      <Header />
      <Helmet>
        <meta name="keywords" content="виробництво, Агроболік Фосфор, новинка, Агроболік, Фосфор, купити, Санберрі Україна, добрива" />
        <title>Купити Агроболік Фосфор у магазині Санберрі Україна</title>
        <link rel="canonical" href="https://sun-ukr.com/phosphor" />
        <meta name="description" content="Органо-мінеральні добрива Санберрі Україна — ефективне живлення для рослин, підвищення врожайності та якості продукції"></meta>
      </Helmet>
      <div className="crumbs">
        <Link className="crumbs__link" to="/">
          <img className="crumbs__logo" src={crumbs} alt="crumbs" />
        </Link>
        <Link className="crumbs__link" to="catalog">
          <img className="crumbs__arrow" src={forward_arrow} alt="forward-arrow" />
          <span className="crumbs__text">Комплексні органо-мінеральні добрива</span>
        </Link>
        <Link className="crumbs__link" to="agrobolikCard">
          <img className="crumbs__arrow" src={forward_arrow} alt="forward-arrow" />
          <span className="crumbs__text">Добрива для позакореневого живлення</span>
        </Link>
        <img className="crumbs__arrow" src={forward_arrow} alt="forward-arrow" />
        <span className="crumbs__text">Агроболік Фосфор</span>
      </div>
      <div className="itemSeed item--new">
        <div className="itemSeed__title">
          <h1 className="itemSeed__title--styles">Агроболік Фосфор</h1>
          <span className="item__new-arr">НОВИНКА!</span>
        </div>
        <div className={"item__stock " + (true && "item__stock--new")}>
          <span className="item__stock-arr">
            в наявності
          </span>
          <span className="item__stock-road">
            Уточнюйте наявність
          </span>
        </div>
        <div className="itemSeed__container">
          <div className="itemSeed__left">
            <div className="test-1">
              <div className="itemSeed__image-container--slider">
                <GoodsSlider />
              </div>
              <div className="itemSeed__center">
                <div className="itemSeed__block">
                  <div className="item__logo">
                    <img className="itemCard__image-logo" src={logo1} alt="logo" />
                  </div>
                  <span className="item__factory-text">
                    Виробник:
                    <span className="item__factory-name"> Санберрі Україна</span>
                  </span>
                </div>
                <div className="characteristic__wrap">
                  <div className="aside__title">Основні характеристики</div>
                  <div className="characteristic__container">
                    <div className="characteristic__label">Комерційна назва</div>
                    <div className="characteristic__value">Агроболік Фосфор</div>
                  </div>
                  <div className="characteristic__container">
                    <div className="characteristic__label">Виробник</div>
                    <div className="characteristic__value">Санберрі Україна</div>
                  </div>
                  <div className="characteristic__container">
                    <div className="characteristic__label">Основний компонент</div>
                    <div className="characteristic__value">Гумат</div>
                  </div>
                  <div className="characteristic__container">
                    <div className="characteristic__label">Допоміжний компонент</div>
                    <div className="characteristic__value">Фосфор, молібден</div>
                  </div>
                </div>
                <div className="item__offer">
                  <div className="item__zone">
                    <div className="item__packing">
                      <span className="item__packing-text">Фасування:</span>
                      <div className="item__packing-position">
                        <div className="item__capacity-tabs">
                          <button
                            className={
                              togglefirstState === 1
                                ? "item__cap-tabs active-item__cap-tabs"
                                : "item__cap-tabs"
                            }
                            onClick={() => toggleFirstTab(1)}
                          >
                            20л
                          </button>
                          <button
                            className={
                              togglefirstState === 2
                                ? "item__cap-tabs active-item__cap-tabs"
                                : "item__cap-tabs"
                            }
                            onClick={() => toggleFirstTab(2)}
                          >
                            10л
                          </button>
                          <button
                            className={
                              togglefirstState === 3
                                ? "item__cap-tabs active-item__cap-tabs"
                                : "item__cap-tabs"
                            }
                            onClick={() => toggleFirstTab(3)}
                          >
                            1л
                          </button>
                          <button
                            className={
                              togglefirstState === 4
                                ? "item__cap-tabs active-item__cap-tabs"
                                : "item__cap-tabs"
                            }
                            onClick={() => toggleFirstTab(4)}
                          >
                            0,5л
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="item__price">
                      <div className="price__charts">
                        <span className="price__item">Роздрібна ціна</span>
                        <div className="price__taxes">
                          <div>i</div>
                          <div class="price__taxes-content fadeInUp">
                            <span>Ціни вказані з ПДВ</span>
                          </div>
                        </div>
                      </div>
                      <div className="price item__capacity-tabs-active">
                        <div
                          className={
                            togglefirstState === 1 ? "capacity  active-capacity" : "capacity"
                          }
                        >
                          {priceFirst}
                        </div>

                        <div
                          className={
                            togglefirstState === 2 ? "capacity  active-capacity" : "capacity"
                          }
                        >
                          {priceSecond}
                        </div>

                        <div
                          className={
                            togglefirstState === 3 ? "capacity  active-capacity" : "capacity"
                          }
                        >
                          {priceThird}
                        </div>

                        <div
                          className={
                            togglefirstState === 4 ? "capacity  active-capacity" : "capacity"
                          }
                        >
                          {priceFourth}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="item__order">
                    <button className="btn-detail--shop" onClick={handleAdd}>
                      До кошика
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-cart-promo">
          <div className="cart-promo__item">
            <div className="cart-promo__ico">
              <img className="card-info_photo" src={verified} alt="verified" />
            </div>
            <div className="cart-promo__wrap">
              <div className="cart-promo__head">Якість гарантовано!</div>
              <div className="cart-promo__label _text-caption">Санберрі Україна пропонує тільки офіційну продукцію</div>
            </div>
          </div>
          <div className="cart-promo__item">
            <div className="cart-promo__ico">
              <img className="card-info_photo" src={time} alt="time" />
            </div>
            <div className="cart-promo__wrap">
              <div className="cart-promo__head">Працюємо 24/7</div>
              <div className="cart-promo__label _text-caption">Ми приймаємо ваші замовлення щодня без перерв та вихідних</div>
            </div>
          </div>
          <div className="cart-promo__item">
            <div className="cart-promo__ico">
              <img className="card-info_photo" src={money} alt="money" />
            </div>
            <div className="cart-promo__wrap">
              <div className="cart-promo__head">Оплата</div>
              <div className="cart-promo__label _text-caption">Пропонуємо готівковий та безготівковий розрахунки за товар</div>
            </div>
          </div>
          <div className="cart-promo__item">
            <div className="cart-promo__ico">
              <img className="card-info_photo" src={deliver} alt="deliver" />
            </div>
            <div className="cart-promo__wrap">
              <div className="cart-promo__head">Доставка</div>
              <div className="cart-promo__label _text-caption">По всій Україні Новою Поштою чи іншими службами доставки</div>
            </div>
          </div>
        </div>
        <div className="seeds-tabs">
          <button
            className={toggleState === 1 ? "seed-tabs active-seed-tabs" : "seed-tabs"}
            onClick={() => toggleTab(1)}
          >
            Опис Товару
          </button>
          <button
            className={toggleState === 2 ? "seed-tabs active-seed-tabs" : "seed-tabs"}
            onClick={() => toggleTab(2)}
          >
            Характеристика
          </button>
          <button
            className={toggleState === 3 ? "seed-tabs active-seed-tabs" : "seed-tabs"}
            onClick={() => toggleTab(3)}
          >
            Схема живлення
          </button>
        </div>
        <div className="seeds-tabs-active">
          <div
            className={toggleState === 1 ? "seeds-active  active-seeds" : "seeds-active"}>
            <Description />
          </div>

          <div
            className={toggleState === 2 ? "seeds-active  active-seeds" : "seeds-active"}>
            <Reference />
          </div>

          <div
            className={toggleState === 3 ? "seeds-active  active-seeds" : "seeds-active"}>
            <Table />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
